import { keepOneOrLine } from '@/utils/utils';
import petalSpinCircle from '../../../imgs/petal_spin_circle.png';

interface PieDataItem {
  name: string;
  value: number;
  rate: number;
  cost: string;
  color: string;
}

export const getHighEnergyPieChartOption = (data: PieDataItem[], total: string) => {
  const colors = data.map(item => item.color);

  const pieData = data.map(item => ({
    name: item.name ?? '--',
    value: item.value ?? 0,
    rate: item.rate ?? 0,
    cost: item.cost,
    itemStyle: { color: item.color },
  }));

  return {
    color: colors,
    legend: { show: false },
    tooltip: {
      trigger: 'item',
      confine: true,
      backgroundColor: 'rgba(4, 13, 24, 0.9)',
      borderColor: 'rgba(45, 141, 255, 0.3)',
      textStyle: { color: '#fff' },
      formatter: (params: any) => {
        const { data } = params;
        return `
          <div style="padding: 8px;">
            <div style="margin-bottom: 4px;">${data.name}</div>
            <div>用能：${data.cost}</div>
            <div>占比：${keepOneOrLine(data.rate)}%</div>
          </div>
        `;
      },
    },
    graphic: {
      elements: [
        {
          type: 'image',
          left: 'center',
          top: 'center',
          style: {
            image: petalSpinCircle,
            x: -28,
            y: -28,
            width: 56,
            height: 56,
          },
          keyframeAnimation: [
            {
              duration: 80000,
              loop: true,
              easing: 'linear',
              keyframes: [
                { percent: 0, rotation: 0, transition: ['rotation'] },
                { percent: 1, rotation: 360, transition: ['rotation'] },
              ],
            },
          ],
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: '高能耗设备用能',
        radius: ['35%', '90%'],
        center: ['50%', '50%'],
        padAngle: 4,
        minAngle: 4,
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 8,
        },
        label: {
          show: true,
          position: 'center',
          formatter: () => `{value|${total}}\n{unit|总计(kWh)}`,
          rich: {
            value: {
              fontSize: 16,
              fontWeight: 600,
              color: '#FFF',
            },
            unit: {
              fontSize: 12,
              color: '#FFF',
              padding: [4, 0, 0, 0],
            },
          },
        },
        data: pieData,
        showEmptyCircle: false,
      },
    ],
  };
};
